import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
    import HintTooltip from '@ve/components/hintTooltip/desktop/HintTooltip.vue';
    import { type THotelCardRightBlock } from '@ve/components/serpHotelCard/types';
    import { formatNumber } from '@ve/services/textModifiers';
    import SearchPageHotelCardRightBlockSearchTimer from './SearchPageHotelCardRightBlockSearchTimer.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'SearchPageHotelCardRightBlockPriceToolTip',
  props: {
    productPrice: null,
    tooltipBottomText: null
  },
  setup(__props: any) {

const props = __props as {
        productPrice: THotelCardRightBlock['productPrice'];
        tooltipBottomText: THotelCardRightBlock['tooltipBottomText'];
    };

    

    const priceText = computed(() => `от ${formatNumber(props.productPrice)}`);

return { __sfc: true,props, priceText, HintTooltip, SearchPageHotelCardRightBlockSearchTimer }
}

})